var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("address-view", {
    attrs: {
      addresses: _vm.addresses,
      v: _vm.$entity.addresses,
      "is-tiled": true,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }